(function () {
  const productStitchingContainer = document.getElementById('product-stitching-container');
  if (!productStitchingContainer) return;

  const productGroupId = productStitchingContainer.dataset.group;
  const productHandle = productStitchingContainer.dataset.handle;
  let stitchedAvailableSizes = productGroupId ? null : new Set();
  let isLoaded = false;

  const normalizeValue = (value = '') => value.trim().toLowerCase();

  const getProductRoot = () => productStitchingContainer.closest('product-info') || document;

  const getSizeOptionElement = () => getProductRoot().querySelector('variant-selects [data-size-option]');

  const getSizeOptionName = () =>
    getSizeOptionElement()?.dataset.sizeOptionName || productStitchingContainer.dataset.sizeOptionName || '';

  const getVariantSizeValue = (variant, sizeOptionName) => {
    const normalizedSizeOptionName = normalizeValue(sizeOptionName);
    const matchedOption = (variant.selectedOptions || []).find(
      (option) => normalizeValue(option.name) === normalizedSizeOptionName
    );

    if (matchedOption?.value) {
      return matchedOption.value;
    }

    if ((variant.selectedOptions || []).length === 1) {
      return variant.selectedOptions[0].value;
    }

    const titleParts = (variant.title || '')
      .split(' / ')
      .map((part) => part.trim())
      .filter(Boolean);

    return titleParts.length ? titleParts[titleParts.length - 1] : '';
  };

  const buildAvailableSizeSet = (products) => {
    const sizeOptionName = getSizeOptionName();
    const availableSizes = new Set();

    products.forEach((product) => {
      (product.variants?.edges || []).forEach(({ node: variant }) => {
        if (!variant.availableForSale) return;

        const sizeValue = getVariantSizeValue(variant, sizeOptionName);
        if (!sizeValue) return;

        availableSizes.add(normalizeValue(sizeValue));
      });
    });

    return availableSizes;
  };

  const applySizeAvailability = () => {
    const sizeOptionElement = getSizeOptionElement();
    if (!sizeOptionElement) return;

    if (productGroupId && stitchedAvailableSizes === null) {
      return;
    }

    Array.from(sizeOptionElement.querySelectorAll('input[type="radio"]')).forEach((input) => {
      const label = input.nextElementSibling?.tagName === 'LABEL' ? input.nextElementSibling : null;
      const isDisabled = input.disabled || input.classList.contains('disabled');
      const keepVisible = stitchedAvailableSizes?.has(normalizeValue(input.value));
      const shouldHide = isDisabled && !input.checked && !keepVisible;

      input.toggleAttribute('hidden', shouldHide);
      label?.toggleAttribute('hidden', shouldHide);
      input.style.display = shouldHide ? 'none' : '';

      if (label) {
        label.style.display = shouldHide ? 'none' : '';
      }
    });
  };

  const renderColorSwatches = (products) => {
    let colorSwatchesHTML = '';
    let containerHTML = '';
    let currentColorName = '';

    if (products.length > 1) {
      for (let i = 0; i < products.length; i += 1) {
        const product = products[i];
        const currentClass = product.handle === productHandle ? 'variant-selector__item--checked' : '';
        const variantNames = (product.variants?.edges || []).map((variant) => variant.node);

        if (currentColorName === '' && product.handle === productHandle) {
          const currentVariantTitle = variantNames[0]?.title || '';
          currentColorName = currentVariantTitle.split(' / ')[0] || '';
        }

        colorSwatchesHTML += `<a href="${product.onlineStoreUrl}" class="variant-selector__choice ${currentClass}">
            <label class="label label--radio variant-selector__item ${currentClass}">
                <figure class="image-lazy variant-selector__item-image image-lazy--contain"><img
                    loading="lazy" src="${product.featuredImage.url}" alt="${product.title}"/></figure>
            </label>
        </a>`;
      }

      if (colorSwatchesHTML !== '') {
        containerHTML = `<div class="variant-selector__option variant-selector__option--colour">
            <div class="variant-selector__name">
                <h5 class="variant-selector__title font-body-bolder">
                    Choose your Colour:
                </h5>
                <span class="variant-selector__current text-subtext">${currentColorName}</span>
            </div>
            <div class="variant-selector__choices-wrapper">
                <div class="variant-selector__choices variant-selector__choices--colour">
                    <div class="variant-selector__choices-wrap">
                        <div class="variant-selector__choices-inner">
                            ${colorSwatchesHTML}
                        </div>
                    </div>
                </div>
            </div>
        </div>`;
      }

      if (!isLoaded) {
        productStitchingContainer.innerHTML = containerHTML;
        isLoaded = true;
      }
    } else {
      productStitchingContainer.style.display = 'none';
    }
  };

  document.addEventListener('variant:changed', applySizeAvailability);

  if (!productGroupId) {
    applySizeAvailability();
    return;
  }

  const apiToken = window.theme.product_stitching.app_token;
  const productFieldsFragment = `
      fragment ProductStitchingProduct on Product {
        handle
        title
        onlineStoreUrl
        availableForSale
        featuredImage {
          url
        }
        variants(first: 50) {
          edges {
            node {
              title
              availableForSale
              selectedOptions {
                name
                value
              }
            }
          }
        }
        metafield: metafield(namespace: $namespace, key: $key) {
          value
          description
          type
        }
      }
  `;

  const filteredProductsQuery = `
      query Swatches($namespace: String!, $key: String!, $value: String!) {
        collection(handle: "all") {
          handle
          products(first: 20,
            filters: {
              productMetafield: {
                namespace: $namespace,
                key: $key,
                value: $value
              }
            }
          ) {
            edges {
              node {
                ...ProductStitchingProduct
              }
            }
          }
        }
      }

      ${productFieldsFragment}
  `;

  const searchedProductsQuery = `
      query ProductStitchingSearch($namespace: String!, $key: String!, $searchQuery: String!) {
        products(first: 50, query: $searchQuery) {
          edges {
            node {
              ...ProductStitchingProduct
            }
          }
        }
      }

      ${productFieldsFragment}
  `;

  const getProductsFromEdges = (edges) =>
    (Array.isArray(edges) ? edges : [])
      .map((edge) => edge.node)
      .filter((product) => {
        return (
          product?.onlineStoreUrl &&
          product.featuredImage?.url &&
          product.metafield?.value === productGroupId
        );
      });

  const fetchProductStitchingData = (query, variables) =>
    fetch(`https://${Shopify.shop}/api/2024-04/graphql.json`, {
      method: 'POST',
      headers: {
        'X-Shopify-Storefront-Access-Token': apiToken,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        query,
        variables,
      }),
    }).then((response) => response.json());

  const baseVariables = {
    namespace: 'ProductStitchingID',
    key: 'ProductStitchingID',
  };

  fetchProductStitchingData(filteredProductsQuery, {
    ...baseVariables,
    value: productGroupId,
  })
    .then((data) => {
      const filteredProducts = getProductsFromEdges(data?.data?.collection?.products?.edges);
      if (filteredProducts.length > 1) return filteredProducts;

      return fetchProductStitchingData(searchedProductsQuery, {
        ...baseVariables,
        searchQuery: productGroupId,
      }).then((fallbackData) => {
        const searchedProducts = getProductsFromEdges(fallbackData?.data?.products?.edges);
        return searchedProducts.length ? searchedProducts : filteredProducts;
      });
    })
    .then((products) => {
      renderColorSwatches(products);
      stitchedAvailableSizes = buildAvailableSizeSet(products);
      applySizeAvailability();
    })
    .catch((error) => {
      console.error('Error:', error);
    });
})();
